jQuery(document).ready(function() {

    //tool tips
    // var aluminum = 'Aluminum is added to steel in very small amounts as a deoxidizer.\nIt is also a grain refiner for improved toughness.';
    // var carbon = 'Increases edge retention and raises tensile strength.\nIncreases hardness and improves resistance to wear and abrasion.';
    // var chromium = 'Increases hardness, tensile strength, and toughness.\nProvides resistance to wear and corrosion.\nAbove 12% and it yields what is generally known as Stainless Steel.';
    // var cobalt = 'Increases strength and hardness, and permits quenching in higher temperatures.\nIntensifies the individual effects of other elements in more complex steels.';
    // var copper = 'Increases corrosion resistance.';
    // var manganese = 'Increases hardenability, wear resistance, and tensile strength.\nDeoxidizes and degasifies to remove oxygen from molten metal.\nIn larger quantities, increases hardness and brittleness.'
    // var molybdenum = 'Increases strength, hardness, hardenability, and toughness.\nImproves machinability and resistance to corrosion.\nPrevents high temperature creep.  Helps to retain fine grain sizes.';
    // var nickel = 'Adds strength and toughness.';
    // var niobium = 'Niobium (Nb) aka Columbium.\nImproves strength and toughness.\nProvides corrosion resistance.\nImproves grain refinement and precipitation hardening.';
    // var nitrogen = 'Used in place of carbon for the steel matrix. The Nitrogen\natom will function in asimilar manner to the carbon atom \nbut offers unusual advantages in corrosion resistance.';
    // var phosphorus = 'Improves strength, machinability, and hardness.\nCreates brittleness in high concentrations.';
    // var silicon = 'Increases strength.\nDeoxidizes and degasifies to remove oxygen from molten metal.';
    // var sulphur = 'Improves machinability when added in minute quantities, but can decrease toughness.';
    // var tungsten = 'Adds strength, toughness, and improves hardenability.';
    // var vanadium = 'Increases strength, wear resistance, and increases toughness.\nLimits grain size.';

 //    jQuery('.steelname').click(function(e) {
 //      var item = jQuery(this).find('block-title').text();
 //      jQuery('ul.elements'+item).toggle()
	// })
	
	//Tooltips
	// jQuery(".tip_trigger").hover(function(){
 //      console.log('********* hovering ************')
	// 	var tip = jQuery(this).find('.steeltip');
 //        var tiptext = eval(jQuery(this).attr('tip-data'));
 //        tip.text(tiptext);
	// 	tip.show(); //Show tooltip
	// }, function() {
 //        var tip = jQuery(this).find('.steeltip');
	// 	tip.hide(); //Hide tooltip		  
	// }).mousemove(function(e) {
  //       var tip = jQuery(this).find('.steeltip');
		// var mousex = e.pageX + 10; //Get X coodrinates
		// var mousey = e.pageY + 5; //Get Y coordinates
		// var tipWidth = tip.width(); //Find width of tooltip
		// var tipHeight = tip.height(); //Find height of tooltip
		
		// //Distance of element from the right edge of viewport
		// var tipVisX = jQuery(window).width() - (mousex + tipWidth);
		// //Distance of element from the bottom of viewport
		// var tipVisY = jQuery(window).height() - (mousey + tipHeight);
		  
		// if ( tipVisX < 20 ) { //If tooltip exceeds the X coordinate of viewport
		// 	mousex = e.pageX - tipWidth + 300;
		// } if ( tipVisY < 20 ) { //If tooltip exceeds the Y coordinate of viewport
		// 	mousey = e.pageY - tipHeight - 20;
		// } 
		// tip.css({  top: mousey, left: mousex });
	//});
})
